import { createStore } from 'store-utils';
import { TabQueryParam } from '../types/settings-types';

const SettingsStore = createStore<SettingsStoreState>(
  {
    currentTab: TabQueryParam.OrgSettings,
  },
  'Settings Store',
);

interface SettingsStoreState {
  currentTab: TabQueryParam;
}

export default SettingsStore;
